// React Related Imports
import ReactDOM from "react-dom";
import React, { ReactNode, useEffect } from "react";

interface ModalProps {
  children: ReactNode;
  actionBar?: ReactNode;
  onClose?: () => void;
}

const Modal: React.FC<ModalProps> = ({ onClose, children, actionBar }) => {
  useEffect(() => {
    document.body.classList.add("overflow-hidden");

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  });

  const modalContainer = document.querySelector(".modal-container");
  if (!modalContainer) return null;

  return ReactDOM.createPortal(
    <div className="z-40 bg-gray">
      <div
        onClick={onClose}
        className="fixed inset-0 bg-gray-300 opacity-80"
      ></div>

      <div
        onClick={onClose}
        className="fixed inset-0 flex items-center justify-center p-2"
      >
        <div
          className="bg-white rounded-lg shadow-lg w-80 max-w-full p-6"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col items-center justify-center">
            {children}
            {actionBar && (
              <div className="flex justify-center mt-4 gap-4">{actionBar}</div>
            )}
          </div>
        </div>
      </div>
    </div>,
    modalContainer
  );
};

export default Modal;
